import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { formatDateWithTime } from './time';
export class ProposalTemplateSummaryModel {
    static fromDTO(dto) {
        return new ProposalTemplateSummaryModel(dto);
    }
    static sortByTitle(a, b) {
        const nameA = a.lowercaseTitle();
        const nameB = b.lowercaseTitle();
        if (nameA < nameB) {
            return -1;
        } else if (nameA > nameB) {
            return 1;
        } else return 0;
    }
    formattedLastUpdatedOn() {
        return formatDateWithTime(this.data.lastUpdatedOn);
    }
    lastUpdatedOn() {
        return this.data.lastUpdatedOn;
    }
    lowercaseTitle() {
        return this.data.title.toLowerCase();
    }
    get id() {
        return this.data.id;
    }
    get title() {
        return this.data.title;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
